var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InterfaceName',{attrs:{"interfaceName":_vm.interfaceName}}),_c('InterfaceSpe',{attrs:{"requestUrl":_vm.requestUrl,"requestMethod":_vm.requestMethod}}),_c('ReturnParam',{attrs:{"returnObj":_vm.returnObj}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }